import ApplicationController from '@/controllers/application_controller'

export default class extends ApplicationController {
  static targets = ['monthlyAgreement', 'checkbox', 'yearlyAgreement', 'valueInput']

  toggle() {
    if (this.checkboxTarget.checked) {
      this.switchToYearlyAgreement()
    } else {
      this.switchToMonthlyAgreement()
    }
  }

  switchToYearlyAgreement() {
    this.checkboxTarget.checked = true
    this.checkboxTarget.value = 'yearly'

    this.monthlyAgreementTarget.classList.remove('text-indigo')
    this.yearlyAgreementTarget.classList.add('text-indigo')

    this.dispatch('change', {
      detail: 'yearly',
    })

    this.valueInputTarget.value = 'yearly'
  }

  switchToMonthlyAgreement() {
    this.checkboxTarget.checked = false
    this.checkboxTarget.value = 'monthly'

    this.monthlyAgreementTarget.classList.add('text-indigo')
    this.yearlyAgreementTarget.classList.remove('text-indigo')

    this.dispatch('change', {
      detail: 'monthly',
    })

    this.valueInputTarget.value = 'monthly'
  }
}
